import * as filters from './filters'

export default Vue => {
  // Filters
  Vue.filter('date', filters.dateFilter)
  Vue.filter('showTimeHMS', filters.showTimeHMS)
  // Vue.filter('projectStatus', filters.projectStatus)
  // Vue.filter('itemStatus', filters.itemStatus)
  // Vue.filter('itemType', filters.itemType)
  // Vue.filter('thumb', filters.thumb)
  Vue.filter('timeFormat', filters.timeFormat)
}
